import React from "react";
import {Colors, Container, Divider, OutlinedInput, Text, ToggleButton, ToggleButtonGroup} from "bounce-ui/backoffice";
import {KeyValueRow} from "../Components";
import {InputAdornment} from "../../../../../../../../bounce-ui/backoffice";
import {getError, HardshipAmountType} from "../utils";

interface IConfigureHardshipPlan {
  hardshipAmount?: HardshipAmountType;
  setHardshipAmount: (value: HardshipAmountType) => void;
  numberOfHardshipInstallments?: number;
  setNumberOfHardshipInstallments: (value: number) => void;
  hardshipCustomAmount?: number;
  setHardshipCustomAmount: (value: number) => void;
  totalBalance: number;
  error: any;
  setError: (value: any) => void;
  editMode: boolean;
}

const ConfigureHardshipPlan = ({
  error,
  hardshipAmount,
  setHardshipAmount,
  hardshipCustomAmount,
  setHardshipCustomAmount,
  numberOfHardshipInstallments,
  setNumberOfHardshipInstallments,
  totalBalance,
  setError,
  editMode,
}: IConfigureHardshipPlan) => {
  return (
    <>
      <Divider sx={{height: "1px", width: "100%", borderColor: Colors.tertiary._300}} />
      <KeyValueRow field={"Number of hardship installments"}>
        <ToggleButtonGroup
          exclusive
          value={numberOfHardshipInstallments}
          onChange={(event: React.MouseEvent<HTMLElement>, value) => setNumberOfHardshipInstallments(value)}
          disabled={!editMode}
        >
          <ToggleButton value={1}>1</ToggleButton>
          <ToggleButton value={2}>2</ToggleButton>
          <ToggleButton value={3}>3</ToggleButton>
          <ToggleButton value={4}>4</ToggleButton>
          <ToggleButton value={5}>5</ToggleButton>
          <ToggleButton value={6}>6</ToggleButton>
        </ToggleButtonGroup>
      </KeyValueRow>
      <KeyValueRow field={"Hardship amount"}>
        <ToggleButtonGroup
          exclusive
          value={hardshipAmount}
          onChange={(event: React.MouseEvent<HTMLElement>, value) => setHardshipAmount(value)}
          disabled={!editMode}
        >
          <ToggleButton value={25}>25$</ToggleButton>
          <ToggleButton value={50}>50$</ToggleButton>
          <ToggleButton value={75}>75$</ToggleButton>
          <ToggleButton value={"custom"}>Custom</ToggleButton>
        </ToggleButtonGroup>
      </KeyValueRow>
      {hardshipAmount === "custom" && (
        <KeyValueRow field={"Custom amount"}>
          <Container row fullWidth sx={{justifyContent: "space-between"}}>
            <Text color={Colors.red._900}>{error || ""}</Text>
            <OutlinedInput
              autoFocus
              type="number"
              value={hardshipCustomAmount || ""}
              inputProps={{min: 0}}
              onChange={(event: any) => {
                setHardshipCustomAmount(event.target.value);
                getError(event, totalBalance, setError);
              }}
              startAdornment={
                <InputAdornment position="start">
                  <Text>$</Text>
                </InputAdornment>
              }
              error={!!error}
              sx={{
                height: "36px",
                width: "144px",
                "& input": {
                  textAlign: "center",
                },
              }}
              disabled={!editMode}
            />
          </Container>
        </KeyValueRow>
      )}
    </>
  );
};

export default ConfigureHardshipPlan;
